import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
  ElementRef,
  NgZone,
  ChangeDetectorRef,
  SimpleChanges,
  ContentChild,
} from "@angular/core";
// import {
//   MapsAPILoader,
//   MouseEvent,
//   AgmMap,
//   GoogleMapsAPIWrapper,
// } from "@agm/core";
import { ExperiencesService } from "@services/experience/experiences.service";
import { SavingEmitterService } from "@services/emitters/saving-emitter.service";
import { ErrorEmitterService } from "@services/emitters/error-emitter.service";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MapGeocoder } from "@angular/google-maps";
import { GoogleMapsComponent } from "@modules/components/google-maps/google-maps.component";
@Component({
  selector: "experience-location",
  templateUrl: "./experience-location.component.html",
  styleUrls: ["./experience-location.component.scss"],
})
export class ExperienceLocationComponent implements OnDestroy, OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  public selectImagePlaceHolder: string = "Select your image";
  public locationDescPlaceHolder: string = "Your location description";
  public mapPin: string = "assets/images/Icons_ic_pin.png";
  public errorLocation: boolean = false;
  @Input("latitude")
  public latitude: number;
  @Input("longitude")
  public longitude: number;
  @Input("locationAddress")
  public locationAddress: string;
  @Input("locationDesc")
  public locationDesc: string;
  @Input("locationName")
  public locationName: string;
  @Input("city")
  public city: string;
  @Input("country")
  public country: string;
  @Input("experience")
  public experience: string;
  @Input("language")
  public language: string;
  @Input("disabled")
  public disabled: boolean;
  @Input("clickBool")
  public clickBool: boolean;
  @Input("draggable")
  public draggable: boolean;
  @Output() locationEmitter = new EventEmitter<any>();
  @ViewChild("search", { static: true, read: ElementRef })
  public searchElementRef: ElementRef;

  @ViewChild("googleMap", { static: true, read: GoogleMapsComponent })
  public googleMapsComponent: GoogleMapsComponent;

  constructor(
    private ngZone: NgZone,
    private experienceSvc: ExperiencesService,
    private savingEmitter: SavingEmitterService,
    private errorEmitter: ErrorEmitterService,
    private changeDetectorRef: ChangeDetectorRef,
    private geocode: MapGeocoder
  ) { }

  async ngOnInit() {
    this.setCurrentLocationOnMap();

    await google.maps.importLibrary("places");

    let autocomplete = new google.maps.places.Autocomplete(
      this.searchElementRef.nativeElement,
      {}
    );
    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        //get the place result
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        //verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }
        let typesIndex = place.types.findIndex(
          (x) => x == "point_of_interest"
        );
        if (typesIndex > -1) {
          this.locationName = place.name;
        } else {
          this.locationName = "";
        }
        //set latitude, longitude and zoom
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        const sublocality = place.address_components.find(x => x.types.indexOf("sublocality_level_1") > -1).short_name;
        const streetName = place.address_components.find(x => x.types.indexOf("route") > -1).long_name;
        const streetNumber = place.address_components.find(x => x.types.indexOf("street_number") > -1).short_name;
        const postalCode = place.address_components.find(x => x.types.indexOf("postal_code") > -1).short_name;
        this.city = place.address_components.find(x => x.types.indexOf("locality") > -1 || x.types.indexOf("postal_town") > -1).short_name;
        this.country = place.address_components.find(x => x.types.indexOf("country") > -1).short_name;
        this.locationAddress = [sublocality, `${streetName} ${streetNumber}`, `${postalCode} ${this.city}`, this.country].join(", ");
        this.setCurrentLocationOnMap();
        this.savingEmitter.sendMessage(true);
        this.addLocationInfo();
        this.changeDetectorRef.detectChanges();
        this.experienceSvc
          .setExperienceCoordinates(
            this.experience,
            this.latitude,
            this.longitude
          )
          .pipe(takeUntil(this.destroyed$))
          .subscribe(
            (x) => {
              this.savingEmitter.sendMessage(false);
            },
            (err) => {
              this.errorEmitter.sendError(true);
            }
          );
      });
    });
  }

  private setCurrentLocationOnMap() {
    if (this.latitude && this.longitude) {
      const latLng = { lat: this.latitude, lng: this.longitude };
      this.googleMapsComponent.setCenter(latLng);
      this.googleMapsComponent.setMarkerAtCenter();
      this.googleMapsComponent.zoom = 18;
    }
  }

  markerDragEnd($event: MouseEvent) {
    if (!this.clickBool) {
      return;
    } else {
      // this.latitude = $event.coords.lat;
      // this.longitude = $event.coords.lng;
      this.getAddress(this.latitude, this.longitude);
    }
  }

  placeMarker($event: google.maps.MapMouseEvent) {
    if (!this.clickBool) {
      return;
    } else {
      this.latitude = $event.latLng.lat();
      this.longitude = $event.latLng.lng();
      this.getAddress(this.latitude, this.longitude);
    }
  }

  getAddress(latitude, longitude) {
    this.savingEmitter.sendMessage(true);
    this.geocode.geocode(
      { location: { lat: latitude, lng: longitude } }).subscribe(
        async ({ results, status }) => {
          if (status === "OK") {
            if (results[0]) {
              this.experienceSvc
                .setExperienceCoordinates(
                  this.experience,
                  this.latitude,
                  this.longitude
                )
                .pipe(takeUntil(this.destroyed$))
                .subscribe(
                  (x) => {
                    this.savingEmitter.sendMessage(false);
                  },
                  (err) => {
                    this.errorEmitter.sendError(true);
                  }
                );

              this.locationAddress = results[0].formatted_address;
              if (results[0].place_id && results[0].types.findIndex((x) => x == "point_of_interest") > -1) {
                const place = new google.maps.places.Place({ id: results[0].place_id });
                await place.fetchFields({ fields: ["displayName"] });
                this.locationName = place.displayName;
              }
              else
                this.locationName = "";

              for (
                let i = 0, len = results[0].address_components.length;
                i < len;
                i++
              ) {
                if (results[0].address_components[i].types[0] == "locality") {
                  this.city = results[0].address_components[i].long_name;
                }
                if (results[0].address_components[i].types[0] == "postal_town") {
                  this.city = results[0].address_components[i].long_name;
                }
                if (results[0].address_components[i].types[0] == "country") {
                  this.country = results[0].address_components[i].short_name;
                }
              }
              this.addLocationInfo();
            } else {
              window.alert("No results found");
            }
          } else {
            window.alert("Geocoder failed due to: " + status);
          }
        }
      );

  }

  public addLocationInfo() {
    this.savingEmitter.sendMessage(true);
    if (!this.locationAddress) {
      this.savingEmitter.sendMessage(false);
      this.errorLocation = true;
      return false;
    } else {
      const emittedObject = {
        expLanguage: this.language,
        expAddress: this.locationAddress,
        expDesc: this.locationDesc,
        addressName: this.locationName,
        latitude: this.latitude,
        longitude: this.longitude,
      };
      this.locationEmitter.emit(emittedObject);
      this.experienceSvc
        .addLocationInfo(
          this.experience,
          this.locationAddress,
          this.locationDesc,
          this.city ? this.city : "",
          this.country ? this.country : "",
          this.language,
          this.locationName
        )
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
          (x) => {
            this.errorLocation = false;
            this.savingEmitter.sendMessage(false);

            this.googleMapsComponent.center = { lat: this.latitude, lng: this.longitude };
          },
          (err) => {
            this.errorEmitter.sendError(true);
          }
        );
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
